export default "__VITE_ASSET__C0$JxwK5__"